import { ReturnAddress, Shipment, ShipmentDevice } from '../types';

export const returnAddresses: ReturnAddress[] = [
  {
    id: 'addr-bcsd',
    location: 'Bay County School District',
    addressee: 'Paul Schatz',
    phone: '443-555-6675',
    email: 'paul.schatz@bcsd.org',
    address: '102 S Hickory Ave, Bel Air MD 21014',
  },
  {
    id: 'addr-kittering',
    location: 'Kittering Elementary',
    addressee: 'Tina Turner',
    phone: '410-555-1232',
    email: 'tina.turner@bcsd.org',
    address: '1400 Emmorton Rd, Bel Air MD 21014',
  },
  {
    id: 'addr-chesapeake',
    location: 'Chesapeake Middle School',
    addressee: 'Tech Department',
    phone: null,
    email: 'tech.department@bcsd.org',
    address: '99 Idlewild St, Bel Air MD 21014',
  },
];

const macbookAir = (
  serial: string,
  filingDate: string,
  school: string,
  assetTagId: string,
  studentName: string,
): ShipmentDevice => ({ makeModel: 'Apple Macbook Air', serialNumber: serial, filingDate, school, assetTagId, studentName });

const dell = (serial: string, filingDate: string, assetTagId: string): ShipmentDevice => ({
  makeModel: 'Dell 3120 Chromebook',
  serialNumber: serial,
  filingDate,
  school: 'Bay County School District',
  assetTagId,
  studentName: 'No Student Assigned',
});

interface ShipmentSeed {
  id: string;
  addedDevices: number;
  createdDate: string;
  returnLocation: string;
  status: Shipment['status'];
  action: Shipment['action'];
  addressId: string;
  devices: ShipmentDevice[];
}

const seeds: ShipmentSeed[] = [
  { id: 'CC0E811', addedDevices: 1, createdDate: '10/08/2025', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [macbookAir('T3W9H6Q2Z5N7', '10/08/2025', 'Long Shore High School', 'N/A', 'Abigale Woods')] },
  { id: '8BD0E1B', addedDevices: 3, createdDate: '10/30/2025', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    { makeModel: 'Apple iPad', serialNumber: 'DLXQK123F18M', filingDate: '10/08/2025', school: 'Kittering Elementary School', assetTagId: 'CBK999', studentName: 'Mirabel Madrigal' },
    { makeModel: 'Lenovo Chromebook NT', serialNumber: 'SNL2H8D4K7W6', filingDate: '12/11/2025', school: 'Chesapeake Middle School', assetTagId: 'CBK814', studentName: 'Noah Martinez' },
    { makeModel: 'Lenovo Chromebook NT', serialNumber: 'SNF5V1L7R9X4', filingDate: '12/02/2025', school: 'Chesapeake Middle School', assetTagId: 'N/A', studentName: 'Ethan Ramirez' },
  ] },
  { id: '3209456', addedDevices: 1, createdDate: '11/03/2025', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    { makeModel: 'Acer Chromebook', serialNumber: 'R2H6L3N8J5D7', filingDate: '10/30/2025', school: 'Kittering Elementary School', assetTagId: 'CBK811', studentName: 'Sophia Nguyen' },
  ] },
  { id: '1EBDF67', addedDevices: 1, createdDate: '11/06/2025', returnLocation: 'Kittering Elementary', status: 'Shipped', action: 'none', addressId: 'addr-kittering', devices: [
    { makeModel: 'Apple iPad', serialNumber: 'M2F7N3G8T54U', filingDate: '11/19/2025', school: 'Kittering Elementary School', assetTagId: 'CBK828', studentName: 'Isabella Reyes' },
  ] },
  { id: '0A64261', addedDevices: 1, createdDate: '11/19/2025', returnLocation: 'Chesapeake Middle School', status: 'Shipped', action: 'none', addressId: 'addr-chesapeake', devices: [
    { makeModel: 'Apple iPad', serialNumber: 'M2F7N3G8T54U', filingDate: '11/19/2025', school: 'Kittering Elementary School', assetTagId: 'CBK828', studentName: 'Isabella Reyes' },
  ] },
  { id: '0DD6743', addedDevices: 1, createdDate: '12/02/2025', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    { makeModel: 'Apple iPad 10th Gen', serialNumber: 'Z4N7K2M8H1Q9', filingDate: '12/02/2025', school: 'Kittering Elementary School', assetTagId: '204389', studentName: 'Liam Patel' },
  ] },
  { id: 'BE87DA0', addedDevices: 1, createdDate: '12/11/2025', returnLocation: 'Kittering Elementary', status: 'Shipped', action: 'none', addressId: 'addr-kittering', devices: [
    macbookAir('ZZ49H6Q2Z83E', '11/13/2025', 'Long Shore High School', 'CBK829', 'Mateo Lombardi'),
  ] },
  { id: '8DA02B0', addedDevices: 5, createdDate: '03/03/2026', returnLocation: 'Chesapeake Middle School', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-chesapeake', devices: [
    dell('BCWY7ZCLT1XT', '05/06/2026', 'DCTLVZ'),
    dell('BCLD3U51UZYT', '05/06/2026', 'DCL2WR'),
    dell('BCSKW4ZJW7ZT', '05/06/2026', 'DC1GUJ'),
    dell('BCXPTQY9KHFT', '05/06/2026', 'DCK2GK'),
    dell('BCE2M1BJLKFT', '05/05/2026', 'DCNT6V'),
  ] },
  { id: 'D090DD1', addedDevices: 2, createdDate: '03/05/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-bcsd', devices: [
    dell('BCTPLA7SCTDT', '05/05/2026', 'DC4X5X'),
    dell('BCSQGK1BV68T', '05/05/2026', 'DC7QGA'),
  ] },
  { id: '7AA62A5', addedDevices: 1, createdDate: '03/09/2026', returnLocation: 'Kittering Elementary', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-kittering', devices: [dell('BCK5JGX2PCKT', '05/05/2026', 'DCE16N')] },
  { id: 'BD34D01', addedDevices: 1, createdDate: '03/23/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-bcsd', devices: [dell('BCXTS4SESJCT', '05/05/2026', 'DC2MAC')] },
  { id: 'C3471B5', addedDevices: 1, createdDate: '04/09/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-bcsd', devices: [dell('BC0HEVFQY0UT', '05/05/2026', 'DC2V25')] },
  { id: '5138231', addedDevices: 1, createdDate: '04/15/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-bcsd', devices: [dell('BCDL3H2EZ0BT', '05/04/2026', 'DC6GZQ')] },
  { id: 'B16B5CF', addedDevices: 1, createdDate: '05/04/2026', returnLocation: 'Kittering Elementary', status: 'Shipped', action: 'none', addressId: 'addr-kittering', devices: [dell('BCDL3H2EZ0BT', '05/04/2026', 'DC6GZQ')] },
  { id: '0C34CD3', addedDevices: 5, createdDate: '05/05/2026', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    dell('BCTPLA7SCTDT', '05/05/2026', 'DC4X5X'),
    dell('BCSQGK1BV68T', '05/05/2026', 'DC7QGA'),
    dell('BCK5JGX2PCKT', '05/05/2026', 'DCE16N'),
    dell('BCXTS4SESJCT', '05/05/2026', 'DC2MAC'),
    dell('BC0HEVFQY0UT', '05/05/2026', 'DC2V25'),
  ] },
  { id: '7469B7A', addedDevices: 5, createdDate: '05/06/2026', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    dell('BCWY7ZCLT1XT', '05/06/2026', 'DCTLVZ'),
    dell('BCLD3U51UZYT', '05/06/2026', 'DCL2WR'),
    dell('BCSKW4ZJW7ZT', '05/06/2026', 'DC1GUJ'),
    dell('BCXPTQY9KHFT', '05/06/2026', 'DCK2GK'),
    dell('BCE2M1BJLKFT', '05/05/2026', 'DCNT6V'),
  ] },
  { id: 'FB60CCF', addedDevices: 5, createdDate: '06/05/2026', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    dell('BCFJMCEEQSJT', '06/05/2026', 'DC2E05'),
    dell('BC7RN21KWA0T', '06/05/2026', 'DCE93W'),
    dell('BCWVBMCC7ZZT', '06/05/2026', 'DCNDYQ'),
    dell('BCMVCVC5L84T', '06/05/2026', 'DC47N7'),
    dell('BC53Y3GXBTCT', '05/06/2026', 'DCSXGJ'),
  ] },
  { id: '1BB4E87', addedDevices: 1, createdDate: '06/17/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'print-and-ship', addressId: 'addr-bcsd', devices: [
    { makeModel: 'Apple iPad 10th gen', serialNumber: 'ZOEIPAD123', filingDate: '06/24/2026', school: 'Kittering Elementary School', assetTagId: 'NA', studentName: 'Zoe Fitzgerald' },
  ] },
  { id: 'E200B6E', addedDevices: 1, createdDate: '07/16/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [dell('BCXAE6J9PFQT', '07/13/2026', 'DCW0P8')] },
  { id: 'AC08438', addedDevices: 1, createdDate: '07/16/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [dell('BC665JZ3KWUT', '07/16/2026', 'DCSVLH')] },
  { id: '76A1979', addedDevices: 1, createdDate: '07/20/2026', returnLocation: 'Kittering Elementary', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-kittering', devices: [dell('BCN71Y6CAVQT', '07/16/2026', 'DCWQEQ')] },
  { id: '52E54D4', addedDevices: 1, createdDate: '07/21/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [dell('BCXJPFHHCCQT', '07/16/2026', 'DC8XP1')] },
  { id: '1F3D8F0', addedDevices: 3, createdDate: '07/28/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [
    dell('BCGTRTKB34RT', '07/16/2026', 'DC2R9G'),
    dell('BCX6BNXCG0RT', '07/16/2026', 'DCQYTP'),
    dell('BC5H99ZY1L2T', '07/16/2026', 'DCL7V1'),
  ] },
  { id: '14E12BF', addedDevices: 5, createdDate: '07/28/2026', returnLocation: 'Bay County School District', status: 'Shipped', action: 'none', addressId: 'addr-bcsd', devices: [
    dell('BC6CHNB673LT', '07/28/2026', 'DCM25C'),
    dell('BC6GTBCHLBKT', '07/28/2026', 'DCPF36'),
    dell('BCM0SWJPK14T', '07/28/2026', 'DCRHTQ'),
    dell('BCAWEX2AZ7CT', '07/28/2026', 'DCXC72'),
    dell('BCYQPBPNBPAT', '07/16/2026', 'DCVKT4'),
  ] },
  { id: '175FDA3', addedDevices: 1, createdDate: '07/29/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [dell('BCTY1TEKL6ZT', '07/16/2026', 'DCDTZU')] },
  { id: 'D4B7697', addedDevices: 2, createdDate: '07/30/2026', returnLocation: 'Bay County School District', status: 'Packing In Progress', action: 'generate-label', addressId: 'addr-bcsd', devices: [
    dell('BC5EGXCFH9TT', '07/16/2026', 'DC194Z'),
    dell('BCRQAMF7GZBT', '07/16/2026', 'DC4TZ4'),
  ] },
];

export const shipments: Shipment[] = seeds.map((seed) => ({
  ...seed,
  uuid: `${seed.id.toLowerCase()}-shipment`,
}));

export function shipmentByUuid(uuid: string | undefined) {
  return shipments.find((s) => s.uuid === uuid);
}

export function addressById(id: string) {
  return returnAddresses.find((a) => a.id === id) ?? returnAddresses[0];
}

export const MAX_SHIPMENT_DEVICES = 5;
